import { useEffect, useRef } from 'react';

/**
 * Ao abrir um registro (novo ou existente) a tela leva ate o formulario. Nas telas de lista o formulario fica DEPOIS da lista:
 * com lista longa (200 linhas) ele sairia da area visivel e o clique parecia nao fazer nada.
 */
export function useRolarAoRegistro<T extends HTMLElement>() {
  const ref = useRef<T>(null);
  useEffect(() => {
    ref.current?.scrollIntoView?.({ block: 'start' });
  }, []);
  return ref;
}
